const SEARCH_CHIP_CONFIGS = [
	{
		facetName: 'on_demand_learning_search',
		inputSelector: '.on-demand-learning-listing-block .facetwp-facet-on_demand_learning_search .facetwp-search',
		containerSelector: '.on-demand-learning-listing-block [data-js="odl-search-chip-container"]',
	},
	{
		facetName: 'funding_search',
		inputSelector: '.fundingpoint-listing-hero-block .facetwp-facet-funding_search .facetwp-search',
		containerSelector: '.fundingpoint-listing-hero-block [data-js="funding-search-chip-container"]',
	},
	{
		facetName: 'training_and_events_search',
		inputSelector: '.training-and-events-listing-block .facetwp-facet-training_and_events_search .facetwp-search',
		containerSelector: '.training-and-events-listing-block [data-js="te-search-chip-container"]',
	},
];

// Returns the DOM container where a search chip should render.
function getSearchChipContainer(containerSelector) {
	return document.querySelector(containerSelector);
}

// Returns the search input element for a facet selector.
function getSearchInput(inputSelector) {
	return document.querySelector(inputSelector);
}

// Reads the active search term from input first, then FacetWP state.
function getFacetSearchValue(facetName, inputSelector) {
	const inputValue = getSearchInput(inputSelector)?.value?.trim() || '';
	if (inputValue !== '') {
		return inputValue;
	}

	const facetValue = window.FWP?.facets?.[facetName];
	if (Array.isArray(facetValue)) {
		return String(facetValue[0] || '').trim();
	}

	return typeof facetValue === 'string' ? facetValue.trim() : '';
}

// Clears a search facet value and triggers a FacetWP refresh.
function clearFacetSearchValue(facetName, inputSelector) {
	const input = getSearchInput(inputSelector);
	if (input) {
		input.value = '';
	}

	if (!window.FWP) return;

	const currentValue = window.FWP.facets?.[facetName];
	window.FWP.facets[facetName] = Array.isArray(currentValue) ? [] : '';

	if (typeof window.FWP.parseFacets === 'function') {
		window.FWP.parseFacets();
	}

	window.FWP.refresh();
}

// Renders a removable chip that mirrors the current search facet term.
export function updateFacetwpSearchChip({ facetName, inputSelector, containerSelector }) {
	const container = getSearchChipContainer(containerSelector);
	if (!container) return;

	container.replaceChildren();

	const term = getFacetSearchValue(facetName, inputSelector);
	if (term === '') return;

	const chip = document.createElement('button');
	const label = document.createElement('span');
	const remove = document.createElement('span');

	chip.type = 'button';
	chip.className = 'search-term-chip';
	chip.setAttribute('aria-label', `Remove search term ${term}`);

	label.className = 'label';
	label.textContent = term;

	remove.className = 'remove';
	remove.setAttribute('aria-hidden', 'true');
	remove.textContent = '×';

	chip.append(label, remove);
	chip.addEventListener('click', () => clearFacetSearchValue(facetName, inputSelector));
	container.append(chip);
}

// Updates all configured search chips in one pass.
function updateAllFacetwpSearchChips() {
	SEARCH_CHIP_CONFIGS.forEach((config) => {
		updateFacetwpSearchChip(config);
	});
}

// Initializes search chips and keeps them updated after FacetWP renders.
export function initFacetwpSearchChips() {
	updateAllFacetwpSearchChips();

	document.addEventListener('facetwp-loaded', () => {
		updateAllFacetwpSearchChips();
	});
}
